var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ticketshop-login" }, [
    _c(
      "div",
      { staticClass: "ticketshop-login__content" },
      [
        !_vm.loggedIn && !_vm.mustOrderAsGuest
          ? [
              _c(
                "div",
                { staticClass: "ticketshop-login__options" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ticketshop-login__option",
                      class: {
                        "ticketshop-login__option--active":
                          _vm.activeOption === 1,
                        "ticketshop-login__option--disabled":
                          _vm.loggedIn ||
                          _vm.isRequesting ||
                          _vm.isDisabledByQuery("login"),
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          attrs: {
                            disabled:
                              _vm.loggedIn ||
                              _vm.isRequesting ||
                              _vm.isDisabledByQuery("login"),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.selectLogin.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("Login"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("logIn.sideNav.logIn")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ticketshop-login__option",
                      class: {
                        "ticketshop-login__option--active":
                          _vm.activeOption === 2,
                        "ticketshop-login__option--disabled":
                          _vm.loggedIn ||
                          _vm.isRequesting ||
                          _vm.isDisabledByQuery("registration"),
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          attrs: {
                            disabled:
                              _vm.loggedIn ||
                              _vm.isRequesting ||
                              _vm.isDisabledByQuery("registration"),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.selectRegistration.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("LoginRegister"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("logIn.sideNav.register")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.mustOrderWithLogin &&
                  !_vm.isDisabledByQuery("guest") &&
                  !_vm.blankoEnabled
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "ticketshop-login__option",
                            class: {
                              "ticketshop-login__option--active":
                                _vm.activeOption === 3,
                              "ticketshop-login__option--disabled":
                                _vm.loggedIn || _vm.isRequesting,
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                attrs: {
                                  disabled: _vm.loggedIn || _vm.isRequesting,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.selectGuest.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("LoginGuest"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("logIn.sideNav.orderAsGuest")
                                    ) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "Modal",
          {
            ref: "addressVerificationModal",
            attrs: { "only-hide-on-close-button": true },
          },
          [
            _c(
              "template",
              { slot: "content" },
              [
                _vm.currentBuyerData
                  ? [
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("logIn.addressVerificationModal.headline")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.forms.name")) +
                            ": " +
                            _vm._s(_vm.currentBuyerData.firstName) +
                            " " +
                            _vm._s(_vm.currentBuyerData.lastName)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.forms.mail")) +
                            ": " +
                            _vm._s(_vm.currentBuyerData.email)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.forms.address")) +
                            ": " +
                            _vm._s(_vm.currentBuyerData.street) +
                            " " +
                            _vm._s(_vm.currentBuyerData.houseNr)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.forms.city")) +
                            ": " +
                            _vm._s(_vm.currentBuyerData.zip) +
                            " " +
                            _vm._s(_vm.currentBuyerData.city)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.forms.state")) +
                            ": " +
                            _vm._s(_vm.stateTitle(_vm.currentBuyerData.state))
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.forms.country")) +
                            ": " +
                            _vm._s(
                              _vm.countryTitle(_vm.currentBuyerData.country)
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ticketshop-login__buttonWrapper" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.changeBuyerData.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("global.links.change")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "button",
                              attrs: { href: _vm.continuationUrl },
                              on: { click: _vm.clearReturnUrl },
                            },
                            [_vm._v(_vm._s(_vm.$t("global.links.continue")))]
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "ticketshop-login--selected-option",
            class: {
              "ticketshop-login--loggedIn":
                _vm.loggedIn || _vm.mustOrderAsGuest,
            },
          },
          [
            _vm.isRequesting
              ? [_c("spinner")]
              : _vm.loggedIn
              ? [
                  !_vm.mustOrderAsGuest
                    ? [
                        _c(
                          "p",
                          { staticClass: "h2 ticketshop-login-headline" },
                          [
                            _vm.isGuestOrder
                              ? [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("logIn.guest.bookAsGuest")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("logIn.loggedIn")) +
                                      "\n            "
                                  ),
                                ],
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.currentBuyerData.firstName) +
                                  " " +
                                  _vm._s(_vm.currentBuyerData.lastName)
                              ),
                            ]),
                            _vm._v(".\n          "),
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enableTicketShop
                    ? [
                        _vm.isGuestOrder
                          ? [
                              _c("p", { staticClass: "h3" }, [
                                _vm._v(_vm._s(_vm.$t("logIn.guest.yourData"))),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("global.forms.name")) +
                                    ": " +
                                    _vm._s(_vm.currentBuyerData.firstName) +
                                    " " +
                                    _vm._s(_vm.currentBuyerData.lastName)
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("global.forms.mail")) +
                                    ": " +
                                    _vm._s(_vm.currentBuyerData.email)
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("global.forms.address")) +
                                    ": " +
                                    _vm._s(_vm.currentBuyerData.street) +
                                    " " +
                                    _vm._s(_vm.currentBuyerData.houseNr)
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("global.forms.city")) +
                                    ": " +
                                    _vm._s(_vm.currentBuyerData.zip) +
                                    " " +
                                    _vm._s(_vm.currentBuyerData.city)
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("global.forms.state")) +
                                    ": " +
                                    _vm._s(
                                      _vm.stateTitle(_vm.currentBuyerData.state)
                                    )
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("global.forms.country")) +
                                    ": " +
                                    _vm._s(
                                      _vm.countryTitle(
                                        _vm.currentBuyerData.country
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "ticketshop-login__buttonWrapper ticketshop-login__buttonWrapper--loggedIn",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.logout(true)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("logIn.guest.removeData"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.needsVerificationModal && false
                                    ? [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button button-inverted",
                                            on: {
                                              click: _vm.openVerificationModal,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("global.links.continue")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button button-inverted button--loggedIn",
                                            attrs: {
                                              href: _vm.continuationUrl,
                                            },
                                            on: { click: _vm.clearReturnUrl },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("global.links.continue")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "ticketshop-login__buttonWrapper ticketshop-login__buttonWrapper--single",
                                },
                                [
                                  _vm.needsVerificationModal && false
                                    ? [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button button-inverted",
                                            on: {
                                              click: _vm.openVerificationModal,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("global.links.continue")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button button-inverted",
                                            attrs: {
                                              href: _vm.continuationUrl,
                                            },
                                            on: { click: _vm.clearReturnUrl },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("global.links.continue")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ],
                        _vm._v(" "),
                        _vm.cart && _vm.isGuestOrder && _vm.mustOrderWithLogin
                          ? [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("logIn.guest.noGuestProduct")
                                  ),
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.cart &&
                        !_vm.isGuestOrder &&
                        _vm.mustOrderAsGuest &&
                        !_vm.mustOrderWithLogin
                          ? [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("logIn.guest.noLoginProduct")
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "button",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.logout(false)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("shopNav.logOut")))]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              : _vm.isGuestSelected
              ? [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submitGuestForm.apply(null, arguments)
                        },
                      },
                    },
                    [
                      !_vm.mustOrderAsGuest
                        ? [
                            false ? void 0 : _vm._e(),
                            _vm._v(" "),
                            _c("h3", [
                              _vm._v(
                                _vm._s(_vm.$t("logIn.guest.orderAsGuest"))
                              ),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showErrors && !_vm.guestFormIsValid
                        ? _c("div", { staticClass: "checkout-form__error" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("global.errorMessages.unfinishedForm")
                                ) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkout-view" }, [
                        _c("div", { staticClass: "checkout__wizard" }, [
                          _c(
                            "div",
                            { staticClass: "checkout-form__container" },
                            [
                              _c("customer-form", {
                                key: "guestlogin",
                                ref: "guestForm",
                                attrs: {
                                  context: "guestlogin",
                                  "customer-data-d-t-o": _vm.guestDTO,
                                  "inventory-url": _vm.inventoryUrl,
                                  "show-errors": _vm.showErrors,
                                  "mail-confirm": "",
                                  "required-fields": [
                                    "salutation",
                                    "firstName",
                                    "lastName",
                                    "email",
                                    "emailConfirm",
                                    "addressType",
                                    "street",
                                    "houseNr",
                                    "zip",
                                    "city",
                                    "country",
                                    "state",
                                    "company",
                                  ],
                                },
                                on: {
                                  update: _vm.updateGuestDTO,
                                  isZipValid: _vm.setIsZipValid,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.isCreatingGuest ? [_c("spinner")] : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ticketshop-login__buttonWrapper ticketshop-login__buttonWrapper--single",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button button-inverted ticketshop-login__submit",
                              class: {
                                "button--disabled":
                                  !_vm.guestFormIsValid || !_vm.isZipValid,
                              },
                              attrs: { type: "submit" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("logIn.guest.continueAsGuest")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ]
              : _vm.isRegistrationSelected
              ? [
                  _c(
                    "div",
                    { staticClass: "selected-option__text" },
                    [
                      _c("h3", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("logIn.register.headline")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.enableTicketShop
                        ? [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("logIn.register.infoText.part1")
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("logIn.register.infoText.part2")
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        : [
                            _c("p", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "logIn.register.infoText.postRegistration"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "ticketshop-login__buttonWrapper ticketshop-login__buttonWrapper--single",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "button button-inverted ticketshop-login__submit",
                          attrs: {
                            href:
                              _vm.loginUrl +
                              "/" +
                              _vm.userLanguage +
                              "/registration?returnUrl=" +
                              _vm.currentUrl,
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("logIn.register.registerNow")))]
                      ),
                    ]
                  ),
                ]
              : _vm.isLoginSelected
              ? [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("logIn.alreadyRegistered")))]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm.enableTicketShop
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.blankoEnabled
                                    ? _vm.$t("logIn.shopInfo.pleaseLogInBlanko")
                                    : _vm.$t("logIn.shopInfo.pleaseLogIn")
                                ) +
                                "\n          "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("logIn.shopInfo.info")) +
                                "\n          "
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "ticketshop-login__buttonWrapper ticketshop-login__buttonWrapper--single",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button button-inverted ticketshop-login__submit",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.toLogin.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.links.toLogin")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }